import { Outlet } from 'react-router-dom'
import AppHeader from './AppHeader'

const TemplateGlobal = () => {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <AppHeader />
      <Outlet />
    </div>
  )
}

export default TemplateGlobal
